import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import moment               from 'moment';

let Quote = require('../../Managers/Quote.js');
let Validation = require('../../Managers/Validation.js');

class DayOfWeek extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeValue: props.defaultValue ? props.defaultValue : null,
        };
    }

    setActiveValue(val) {
        let validation = Validation.validate(this.props.dataValidation, val, 'not_null')[0];

        this.setState(Object.assign({}, validation, { day: val, activeValue: val }), () => {
            this.props.isValid(validation.isValid);
        });

        Quote.set(this.props.storageKey, parseInt(val), this.props.source);
        Quote.setAnswer(this.props.storageKey, parseInt(val));
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    handleValidation(e) {
        return this.setActiveValue(e);
    }

    render() {
        return(
            <div className="question-input">
                <select
                    id={this.props.fieldName}
                    name={this.props.fieldName}
                    onChange={(event) => { this.setActiveValue(event.target.value); }}
                    defaultValue={this.state.activeValue}
                >
                    <option value={this.props.defaultValue}>{this.props.defaultText}</option>
                    {Array.apply(0, Array(7)).map(function (x, i) {
                        let day = String(i + 1);
                        return <option key={day} value={day}>{moment().isoWeekday(i + 1).format('dddd')}</option>;
                    })}
                </select>
            </div>
        );
    }
}

DayOfWeek.propTypes = {
    fieldName:      PropTypes.string.isRequired,
    storageKey:     PropTypes.string.isRequired,
    defaultText:    PropTypes.string,
    defaultValue:   PropTypes.number,
    dataValidation: PropTypes.string,
    source:         PropTypes.string,
    isValid:        PropTypes.func,
};

DayOfWeek.defaultProps = {
    defaultText: '-please select-',
    defaultValue: 0,
};

export default DayOfWeek;


// WEBPACK FOOTER //
// ./src/components/Fields/Dates/DayOfWeek.js